'use strict';

var React = require('react');

var SvgBuyButtonHorizontalLayoutMajor = function SvgBuyButtonHorizontalLayoutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm14 0v1h2v-1.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v2h1zm-14 13v1h1v2h-1.5a1.5 1.5 0 0 1-1.5-1.5v-1.5h2zm14 1h-1v2h1.5a1.5 1.5 0 0 0 1.5-1.5v-1.5h-2v1zm-8-3v-8h-6v8h6zm0 5h-3v-2h3v2zm-3-16h3v-2h-3v2zm8 16h-3v-2h3v2zm-3-16h3v-2h-3v2zm6 5h-6v-2h6v2zm-6 4h4v-2h-4v2z"
  }));
};

exports.SvgBuyButtonHorizontalLayoutMajor = SvgBuyButtonHorizontalLayoutMajor;
